export const cmMonsters = [
  {
    name: "Animated Broom",
    source: "CM",
    page: 20,
    size: ["S"],
    type: "construct",
    ac: [
      {
        ac: 15,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 17,
      formula: "5d6",
    },
    speed: {
      walk: 0,
      fly: {
        number: 50,
        condition: "(hover)",
      },
      canHover: true,
    },
    str: 10,
    dex: 17,
    con: 10,
    int: 1,
    wis: 5,
    cha: 1,
    senses: ["blindsight 120 ft. (blind beyond this radius)"],
    passive: 7,
    immune: ["poison", "psychic"],
    conditionImmune: [
      "blinded",
      "charmed",
      "deafened",
      "exhaustion",
      "frightened",
      "paralyzed",
      "petrified",
      "poisoned",
      "prone",
    ],
    cr: "1/4",
    trait: [
      {
        name: "False Object",
        entries: [
          "If the broom is motionless at the start of combat, it has advantage on its initiative roll. Moreover, if a creature hasn't observed the broom move or act, that creature must succeed on a {@dc 15} Wisdom (Perception) check to discern that the broom is animate.",
        ],
      },
      {
        name: "Flyby",
        entries: [
          "The broom doesn't provoke opportunity attacks when it flies out of an enemy's reach.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: ["The broom makes two melee attacks."],
      },
      {
        name: "Broomstick",
        entries: [
          "{@atk mw} {@hit 5} to hit, reach 5 ft., one target. {@h}5 ({@damage 1d4 + 3}) bludgeoning damage.",
        ],
      },
    ],
    traitTags: ["Flyby"],
    senseTags: ["B"],
    actionTags: ["Multiattack"],
    damageTags: ["B"],
    miscTags: ["MW"],
    hasToken: true,
  },
  {
    name: "Animated Chained Library",
    source: "CM",
    page: 24,
    size: ["L"],
    type: "construct",
    ac: [
      {
        ac: 14,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 45,
      formula: "6d10 + 12",
    },
    speed: {
      walk: 10,
    },
    str: 15,
    dex: 8,
    con: 14,
    int: 1,
    wis: 5,
    cha: 1,
    senses: ["blindsight 30 ft. (blind beyond this radius)"],
    passive: 7,
    immune: ["poison", "psychic"],
    conditionImmune: [
      "blinded",
      "charmed",
      "deafened",
      "exhaustion",
      "frightened",
      "paralyzed",
      "petrified",
      "poisoned",
      "prone",
    ],
    cr: "1",
    trait: [
      {
        name: "False Object",
        entries: [
          "If the library is motionless at the start of combat, it has advantage on its initiative roll. Moreover, if a creature hasn't observed the library move or act, that creature must succeed on a {@dc 15} Wisdom (Perception) check to discern that the library is animate.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: ["The library makes two attacks."],
      },
      {
        name: "Chained Book",
        entries: [
          "{@atk mw} {@hit 4} to hit, reach 5 ft., one target. {@h}6 ({@damage 1d8 + 2}) bludgeoning damage, and if the target is a creature, it is {@condition grappled} (escape {@dc 12}).",
        ],
      },
    ],
    senseTags: ["B"],
    actionTags: ["Multiattack"],
    damageTags: ["B"],
    miscTags: ["MW"],
    conditionInflict: ["grappled"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Arrant Quill",
    isNpc: true,
    isNamedCreature: true,
    source: "CM",
    page: 157,
    size: ["M"],
    type: {
      type: "humanoid",
      tags: ["human"],
    },
    alignment: ["N", "E"],
    ac: [14],
    hp: {
      average: 135,
      formula: "18d8 + 54",
    },
    speed: {
      walk: 30,
    },
    str: 10,
    dex: 18,
    con: 16,
    int: 16,
    wis: 15,
    cha: 20,
    save: {
      int: "+7",
      wis: "+6",
      cha: "+9",
    },
    skill: {
      arcana: "+11",
      deception: "+9",
      history: "+7",
      performance: "+13",
    },
    passive: 12,
    languages: ["Common", "Draconic", "Elvish", "Undercommon"],
    cr: "11",
    spellcasting: [
      {
        name: "Spellcasting",
        headerEntries: [
          "Quill casts one of the following spells using Charisma as the spellcasting ability (save {@dc 17}):",
        ],
        will: [
          "{@spell light}",
          "{@spell mage hand}",
          "{@spell prestidigitation}",
        ],
        daily: {
          "3e": [
            "{@spell detect magic}",
            "{@spell dispel magic}",
            "{@spell faerie fire}",
            "{@spell hold monster}",
          ],
          "1e": ["{@spell mind blank}", "{@spell teleport}"],
        },
        ability: "cha",
        displayAs: "action",
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: [
          "Quill makes two attacks with his dagger and uses Supreme Mockery.",
        ],
      },
      {
        name: "Dagger",
        entries: [
          "{@atk mw,rw} {@hit 8} to hit, reach 5 ft. or range 20/60 ft., one target. {@h}6 ({@damage 1d4 + 4}) piercing damage.",
        ],
      },
      {
        name: "Quill's Fable {@recharge}",
        entries: [
          "Quill utters a short fable while targeting up to five creatures within 30 feet of him that he can see. Each target that can hear Quill's magical fable must make a {@dc 17} Wisdom saving throw, taking 36 ({@damage 8d8}) psychic damage on a failed save, or half as much damage on a successful one.",
        ],
      },
      {
        name: "Supreme Mockery",
        entries: [
          "Quill hurls a string of insults laced with enchantments at a creature he can see within 60 feet of him. If the creature can hear Quill (though it need not understand him), it must succeed on a {@dc 17} Wisdom saving throw or take 66 ({@damage 12d10}) psychic damage and have disadvantage on the next attack roll it makes before the end of its next turn.",
        ],
      },
    ],
    attachedItems: ["dagger|phb"],
    actionTags: ["Multiattack"],
    languageTags: ["C", "DR", "E", "U"],
    damageTags: ["P", "Y"],
    spellcastingTags: ["O"],
    miscTags: ["MW", "RW", "THW"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Bak Mei",
    isNpc: true,
    isNamedCreature: true,
    source: "CM",
    page: 168,
    size: ["M"],
    type: {
      type: "humanoid",
      tags: ["human"],
    },
    alignment: ["L", "E"],
    ac: [
      {
        ac: 17,
        from: ["Unarmored Defense"],
      },
    ],
    hp: {
      average: 102,
      formula: "12d8 + 48",
    },
    speed: {
      walk: 40,
    },
    str: 10,
    dex: 18,
    con: 18,
    int: 13,
    wis: 17,
    cha: 16,
    save: {
      str: "+5",
      dex: "+9",
      con: "+9",
      int: "+6",
      wis: "+8",
      cha: "+8",
    },
    skill: {
      acrobatics: "+9",
      athletics: "+5",
      medicine: "+8",
      religion: "+6",
      stealth: "+9",
    },
    passive: 13,
    resist: ["poison", "thunder"],
    conditionImmune: ["charmed", "frightened", "paralyzed"],
    languages: ["Auran", "Common"],
    cr: "13",
    trait: [
      {
        name: "Legendary Resistance (2/Day)",
        entries: [
          "If Bak Mei fails a saving throw, he can choose to succeed instead.",
        ],
      },
      {
        name: "Special Equipment",
        entries: [
          "Bak Mei carries a {@item staff of striking} with 10 charges.",
        ],
      },
      {
        name: "Unarmored Defense",
        entries: [
          "While Bak Mei is wearing no armor and wielding no shield, his AC includes his Wisdom modifier.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: [
          "Bak Mei attacks three times: twice with Thunder Strike and once with his staff of striking.",
        ],
      },
      {
        name: "Thunder Strike",
        entries: [
          "{@atk mw} {@hit 9} to hit, reach 5 ft., one target. {@h}15 ({@damage 2d10 + 4}) thunder damage, and if the target is a creature, it must succeed on a {@dc 17} Constitution saving throw or be {@condition deafened} and {@condition stunned} until the start of Bak Mei's next turn.",
        ],
      },
      {
        name: "Staff of Striking",
        entries: [
          "{@atk mw} {@hit 9} to hit, reach 5 ft., one target. {@h}3 ({@damage 1d6}) bludgeoning damage, or 4 ({@damage 1d8}) bludgeoning damage when used with two hands, and Bak Mei can expend up to 3 of the staff's charges. For each expended charge, the target takes an extra {@damage 1d6} force damage.",
        ],
      },
      {
        name: "Heal Self (Recharges after a Long Rest)",
        entries: [
          "Bak Mei regains {@dice 2d8 + 4} hit points, and all levels of {@condition exhaustion} end on him.",
        ],
      },
    ],
    bonus: [
      {
        name: "Nimble Escape",
        entries: ["Bak Mei takes the Disengage or Hide action."],
      },
    ],
    reaction: [
      {
        name: "Deflect Missile",
        entries: [
          "In response to being hit by a ranged weapon attack, Bak Mei deflects the missile. The damage he takes from the attack is reduced by {@dice 1d10 + 12}. If the damage is reduced to 0, Bak Mei catches the missile if it's small enough to hold in one hand and Bak Mei has a hand free.",
        ],
      },
    ],
    legendary: [
      {
        name: "Crane Dance",
        entries: [
          "Bak Mei moves up to 20 feet. This movement does not provoke opportunity attacks.",
        ],
      },
      {
        name: "Thunder Strike (Costs 2 Actions)",
        entries: ["Bak Mei uses Thunder Strike."],
      },
    ],
    traitTags: ["Legendary Resistances"],
    actionTags: ["Multiattack"],
    languageTags: ["AU", "C"],
    damageTags: ["B", "T"],
    miscTags: ["MW"],
    conditionInflict: ["deafened", "stunned"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Canopic Golem",
    source: "CM",
    page: 179,
    size: ["L"],
    type: "construct",
    ac: [
      {
        ac: 17,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 252,
      formula: "24d10 + 120",
    },
    speed: {
      walk: 30,
    },
    str: 20,
    dex: 10,
    con: 20,
    int: 7,
    wis: 11,
    cha: 1,
    save: {
      int: "+3",
      wis: "+5",
      cha: "+0",
    },
    senses: ["darkvision 120 ft."],
    passive: 10,
    immune: ["poison"],
    conditionImmune: [
      "blinded",
      "charmed",
      "deafened",
      "exhaustion",
      "frightened",
      "paralyzed",
      "petrified",
      "poisoned",
    ],
    cr: "13",
    trait: [
      {
        name: "Limited Spell Immunity",
        entries: [
          "The golem automatically succeeds on saving throws against spells of 7th level or lower, and the attack rolls of such spells always miss it.",
        ],
      },
      {
        name: "Unusual Nature",
        entries: ["The golem doesn't require air, food, drink, or sleep."],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: ["The golem makes two attacks."],
      },
      {
        name: "Slam",
        entries: [
          "{@atk mw} {@hit 10} to hit, reach 5 ft., one target. {@h}27 ({@damage 4d10 + 5}) force damage.",
        ],
      },
      {
        name: "Crystal Dart",
        entries: [
          "{@atk rw} {@hit 10} to hit, range 120 ft., one target. {@h}14 ({@damage 2d8 + 5}) force damage.",
        ],
      },
    ],
    reaction: [
      {
        name: "Spell Deflection",
        entries: [
          "In response to a spell attack missing the golem, it causes that spell to hit another creature within 120 feet of it that it can see.",
        ],
      },
    ],
    traitTags: ["Unusual Nature"],
    senseTags: ["SD"],
    actionTags: ["Multiattack"],
    damageTags: ["O"],
    miscTags: ["MW", "RW", "THW"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Chwinga",
    source: "CM",
    page: 212,
    _copy: {
      name: "Chwinga",
      source: "ToA",
    },
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Cloud Giant Ghost",
    source: "CM",
    page: 146,
    size: ["H"],
    type: "undead",
    ac: [
      {
        ac: 15,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 104,
      formula: "16d12",
    },
    speed: {
      walk: 0,
      fly: {
        number: 40,
        condition: "(hover)",
      },
      canHover: true,
    },
    str: 27,
    dex: 11,
    con: 10,
    int: 12,
    wis: 16,
    cha: 17,
    save: {
      wis: "+7",
      cha: "+7",
    },
    skill: {
      perception: "+7",
    },
    senses: ["darkvision 120 ft."],
    passive: 17,
    resist: ["cold"],
    immune: ["necrotic", "poison"],
    conditionImmune: [
      "charmed",
      "exhaustion",
      "frightened",
      "grappled",
      "paralyzed",
      "petrified",
      "poisoned",
      "prone",
      "restrained",
    ],
    languages: ["Common", "Giant"],
    cr: "9",
    spellcasting: [
      {
        name: "Spellcasting",
        headerEntries: [
          "The ghost casts one of the following spells, using Charisma as the spellcasting ability and requiring no material components:",
        ],
        will: ["{@spell fog cloud}"],
        daily: {
          1: ["{@spell control weather}"],
          3: ["{@spell telekinesis}"],
        },
        ability: "cha",
        displayAs: "action",
      },
    ],
    trait: [
      {
        name: "Ethereal Sight",
        entries: [
          "The ghost can see 120 feet into the Ethereal Plane when it is on the Material Plane, and vice versa.",
        ],
      },
      {
        name: "Incorporeal Movement",
        entries: [
          "The ghost can move through other creatures and objects as if they were {@quickref difficult terrain||3}. It takes 5 ({@damage 1d10}) force damage if it ends its turn inside an object.",
        ],
      },
      {
        name: "Regeneration",
        entries: [
          "The ghost regains 10 hit points at the start of its turn. If the ghost takes radiant damage or damage from a magic weapon, this trait doesn't function at the start of the ghost's next turn. The ghost dies only if it starts its turn with 0 hit points and doesn't regenerate.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: ["The ghost makes two melee attacks."],
      },
      {
        name: "Spectral Weapon",
        entries: [
          "{@atk mw} {@hit 12} to hit, reach 10 ft., one target. {@h}21 ({@damage 3d8 + 8}) force damage.",
        ],
      },
      {
        name: "Etherealness",
        entries: [
          "The ghost enters the Ethereal Plane from the Material Plane, or vice versa. It is visible on the Material Plane while it is in the Border Ethereal, and vice versa, yet it can't affect or be affected by anything on the other plane.",
        ],
      },
      {
        name: "Wind Howl {@recharge}",
        entries: [
          "The ghost emits a dreadful howl that summons a cold, biting wind. This wind engulfs up to three creatures of the ghost's choice that it can see within 60 feet of it. Each target is pulled up to 20 feet toward the ghost and must make a {@dc 15} Constitution saving throw, taking 16 ({@damage 3d10}) cold damage on a failed save, or half as much damage on a successful one.",
        ],
      },
    ],
    traitTags: ["Incorporeal Movement", "Regeneration"],
    senseTags: ["SD"],
    actionTags: ["Multiattack"],
    languageTags: ["C", "GI"],
    damageTags: ["C", "O"],
    spellcastingTags: ["O"],
    miscTags: ["MW", "RCH"],
    hasToken: true,
    hasFluffImages: true,
  },
  {
    name: "Constructed Commoner",
    source: "CM",
    page: 149,
    size: ["M"],
    type: "construct",
    ac: [
      {
        ac: 15,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 6,
      formula: "1d8 + 2",
    },
    speed: {
      walk: 25,
    },
    str: 10,
    dex: 10,
    con: 15,
    int: 10,
    wis: 10,
    cha: 10,
    passive: 10,
    immune: ["poison"],
    conditionImmune: ["exhaustion", "poisoned"],
    languages: ["Common"],
    cr: "0",
    trait: [
      {
        name: "Unusual Nature",
        entries: [
          "The commoner doesn't require air, food, drink, or sleep, and it gains no benefit from finishing a short or long rest. When it drops to 0 hit points, it becomes a lifeless object.",
        ],
      },
    ],
    action: [
      {
        name: "Club",
        entries: [
          "{@atk mw} {@hit 2} to hit, reach 5 ft., one target. {@h}2 ({@damage 1d4}) bludgeoning damage.",
        ],
      },
    ],
    attachedItems: ["club|phb"],
    traitTags: ["Unusual Nature"],
    languageTags: ["C"],
    damageTags: ["B"],
    miscTags: ["MW"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Corrupted Avatar of Lurue",
    source: "CM",
    page: 123,
    size: ["L"],
    type: "monstrosity",
    ac: [
      {
        ac: 14,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 90,
      formula: "12d10 + 24",
    },
    speed: {
      walk: 50,
      fly: {
        number: 50,
        condition: "(hover)",
      },
      canHover: true,
    },
    str: 18,
    dex: 14,
    con: 15,
    int: 11,
    wis: 17,
    cha: 16,
    save: {
      int: "+3",
      wis: "+6",
      cha: "+6",
    },
    senses: ["darkvision 60 ft."],
    passive: 13,
    immune: ["poison"],
    conditionImmune: ["charmed", "paralyzed", "poisoned"],
    languages: ["Celestial", "Elvish", "Sylvan", "telepathy 60 ft."],
    cr: "8",
    action: [
      {
        name: "Multiattack",
        entries: [
          "The avatar makes two attacks: one with its hooves and one with its horn.",
        ],
      },
      {
        name: "Hooves",
        entries: [
          "{@atk mw} {@hit 7} to hit, reach 5 ft., one target. {@h}32 ({@damage 8d6 + 4}) necrotic damage.",
        ],
      },
      {
        name: "Horn",
        entries: [
          "{@atk mw} {@hit 7} to hit, reach 5 ft., one target. {@h}32 ({@damage 8d6 + 4}) necrotic damage. If the target is a humanoid, it must succeed on a {@dc 13} Wisdom saving throw or be transformed into a wolf under the avatar's control. This transformation lasts for 1 hour, or until the target drops to 0 hit points or dies. The target's game statistics are replaced by the wolf's statistics, but it retains its hit points. The target is limited in the actions it can perform by the nature of its wolf form, and it can't speak, cast spells, or take any other action that requires hands or speech. The target's gear melds into the new form, and it can't activate, use, wield, or otherwise benefit from any of its equipment.",
        ],
      },
    ],
    senseTags: ["D"],
    actionTags: ["Multiattack"],
    languageTags: ["CE", "E", "S", "TP"],
    damageTags: ["N"],
    miscTags: ["MW"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Dragon Tortoise",
    source: "CM",
    page: 205,
    _copy: {
      name: "Dragon Turtle",
      source: "MM",
      _mod: {
        trait: {
          mode: "removeArr",
          names: "Amphibious",
        },
        action: {
          mode: "replaceArr",
          replace: "Steam Breath {@recharge 5}",
          items: {
            name: "Sand Breath {@recharge 5}",
            entries: [
              "The dragon tortoise exhales abrasive sand in a 60-foot cone. Each creature in that area must make a {@dc 18} Constitution saving throw, taking 52 ({@damage 15d6}) slashing damage on a failed save, or half as much damage on a successful one.",
            ],
          },
        },
      },
    },
    speed: {
      walk: 20,
    },
    languages: ["Draconic", "Terran"],
    languageTags: ["DR", "T"],
    hasToken: true,
    hasFluff: true,
  },
  {
    name: "Faerl",
    isNpc: true,
    isNamedCreature: true,
    source: "CM",
    page: 104,
    size: ["M"],
    type: {
      type: "humanoid",
      tags: ["elf"],
    },
    alignment: ["N", "E"],
    ac: [
      {
        ac: 15,
        from: ["{@item breastplate|PHB}"],
      },
    ],
    hp: {
      average: 9,
      formula: "2d8",
    },
    speed: {
      walk: 30,
    },
    str: 11,
    dex: 12,
    con: 11,
    int: 12,
    wis: 14,
    cha: 16,
    skill: {
      deception: "+5",
      insight: "+4",
      persuasion: "+5",
    },
    passive: 12,
    languages: ["Common", "Elvish"],
    cr: "1/8",
    trait: [
      {
        name: "Fey Ancestry",
        entries: [
          "Faerl has advantage on saving throws against being {@condition charmed}, and magic can't put him to sleep.",
        ],
      },
    ],
    action: [
      {
        name: "Rapier",
        entries: [
          "{@atk mw} {@hit 3} to hit, reach 5 ft., one target. {@h}5 ({@damage 1d8 + 1}) piercing damage.",
        ],
      },
    ],
    reaction: [
      {
        name: "Parry",
        entries: [
          "Faerl adds 2 to his AC against one melee attack that would hit it. To do so, he must see the attacker and be wielding a melee weapon.",
        ],
      },
    ],
    attachedItems: ["rapier|phb"],
    traitTags: ["Fey Ancestry"],
    actionTags: ["Parry"],
    languageTags: ["C", "E"],
    damageTags: ["P"],
    miscTags: ["MW"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Fungal Servant",
    source: "CM",
    page: 217,
    size: ["M"],
    type: "undead",
    alignment: ["L", "E"],
    ac: [
      {
        ac: 17,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 97,
      formula: "13d8 + 39",
    },
    speed: {
      walk: 20,
    },
    str: 18,
    dex: 10,
    con: 17,
    int: 11,
    wis: 18,
    cha: 16,
    save: {
      con: "+8",
      int: "+5",
      wis: "+9",
      cha: "+8",
    },
    skill: {
      history: "+5",
      religion: "+5",
    },
    senses: ["darkvision 60 ft."],
    passive: 14,
    immune: [
      "necrotic",
      "poison",
      {
        immune: ["bludgeoning", "piercing", "slashing"],
        note: "from nonmagical attacks",
        cond: true,
      },
    ],
    vulnerable: ["fire"],
    conditionImmune: [
      "charmed",
      "exhaustion",
      "frightened",
      "paralyzed",
      "poisoned",
    ],
    languages: ["The languages it knew in life"],
    cr: "15",
    spellcasting: [
      {
        name: "Spellcasting",
        headerEntries: [
          "The fungal servant is a 10th-level spellcaster. Its spellcasting ability is Wisdom (spell save {@dc 17}, {@hit 9} to hit with spell attacks). The fungal servant has the following cleric spells prepared:",
        ],
        spells: {
          0: {
            spells: ["{@spell sacred flame}", "{@spell thaumaturgy}"],
          },
          1: {
            slots: 4,
            spells: [
              "{@spell command}",
              "{@spell guiding bolt}",
              "{@spell shield of faith}",
            ],
          },
          2: {
            slots: 3,
            spells: [
              "{@spell hold person}",
              "{@spell silence}",
              "{@spell spiritual weapon}",
            ],
          },
          3: {
            slots: 3,
            spells: ["{@spell animate dead}", "{@spell dispel magic}"],
          },
          4: {
            slots: 3,
            spells: ["{@spell divination}", "{@spell guardian of faith}"],
          },
          5: {
            slots: 2,
            spells: ["{@spell contagion}", "{@spell insect plague}"],
          },
          6: {
            slots: 1,
            spells: ["{@spell harm}"],
          },
        },
        ability: "wis",
      },
    ],
    trait: [
      {
        name: "Magic Resistance",
        entries: [
          "The fungal servant has advantage on saving throws against spells and other magical effects.",
        ],
      },
      {
        name: "Rejuvenation",
        entries: [
          "A destroyed fungal servant gains a new body in 24 hours if its heart is intact, regaining all its hit points and becoming active again. The new body appears within 5 feet of the fungal servant's heart.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: [
          "The fungal servant can use its Dreadful Glare and makes one attack with its rotting fist.",
        ],
      },
      {
        name: "Rotting Fist",
        entries: [
          "{@atk mw} {@hit 9} to hit, reach 5 ft., one target. {@h}14 ({@damage 3d6 + 4}) bludgeoning damage plus 21 ({@damage 6d6}) necrotic damage. If the target is a creature, it must succeed on a {@dc 16} Constitution saving throw or be cursed with mummy rot. The cursed target can't regain hit points, and its hit point maximum decreases by 10 ({@dice 3d6}) for every 24 hours that elapse. If the curse reduces the target's hit point maximum to 0, the target dies, and its body turns to spores. The curse lasts until removed by the {@spell remove curse} spell or other magic.",
        ],
      },
      {
        name: "Dreadful Glare",
        entries: [
          "The fungal servant targets one creature it can see within 60 feet of it. If the target can see the fungal servant, it must succeed on a {@dc 16} Wisdom saving throw against this magic or become {@condition frightened} until the end of the fungal servant's next turn. If the target fails the saving throw by 5 or more, it is also {@condition paralyzed} for the same duration. A target that succeeds on the saving throw is immune to the Dreadful Glare of all fungal servants for the next 24 hours.",
        ],
      },
    ],
    legendary: [
      {
        name: "Attack",
        entries: [
          "The fungal servant makes one attack with its rotting fist or uses its Dreadful Glare.",
        ],
      },
      {
        name: "Blinding Spores",
        entries: [
          "Blinding spores swirls magically around the fungal servant. Each creature within 5 feet of the fungal servant must succeed on a {@dc 16} Constitution saving throw or be {@condition blinded} until the end of the creature's next turn.",
        ],
      },
      {
        name: "Blasphemous Word (Costs 2 Actions)",
        entries: [
          "The fungal servant utters a blasphemous word. Each non-undead creature within 10 feet of the fungal servant that can hear the magical utterance must succeed on a {@dc 16} Constitution saving throw or be {@condition stunned} until the end of the fungal servant's next turn.",
        ],
      },
      {
        name: "Channel Negative Energy (Costs 2 Actions)",
        entries: [
          "The fungal servant magically unleashes negative energy. Creatures within 60 feet of the fungal servant, including ones behind barriers and around corners, can't regain hit points until the end of the fungal servant's next turn.",
        ],
      },
      {
        name: "Whirlwind of Spores (Costs 2 Actions)",
        entries: [
          "The fungal servant magically transforms into a whirlwind of spores, moves up to 60 feet, and reverts to its normal form. While in whirlwind form, the fungal servant is immune to all damage, and it can't be {@condition grappled}, {@condition petrified}, knocked {@condition prone}, {@condition restrained}, or {@condition stunned}. Equipment worn or carried by the fungal servant remain in its possession.",
        ],
      },
    ],
    traitTags: ["Magic Resistance", "Rejuvenation"],
    senseTags: ["D"],
    actionTags: ["Multiattack"],
    languageTags: ["LF"],
    damageTags: ["B", "N"],
    damageTagsSpell: ["N", "O", "P", "R"],
    spellcastingTags: ["CC"],
    miscTags: ["AOE", "MW"],
    conditionInflict: ["blinded", "frightened", "paralyzed", "stunned"],
    conditionInflictSpell: [
      "blinded",
      "deafened",
      "paralyzed",
      "poisoned",
      "prone",
      "stunned",
    ],
    hasToken: true,
  },
  {
    name: "Gingwatzim",
    source: "CM",
    page: 27,
    size: ["S"],
    type: {
      type: "aberration",
      tags: ["shapechanger"],
    },
    ac: [12],
    hp: {
      average: 39,
      formula: "6d6 + 18",
    },
    speed: {
      walk: 30,
      fly: {
        number: 30,
        condition: "(hover) in its true form only",
      },
      canHover: true,
    },
    str: 3,
    dex: 15,
    con: 16,
    int: 4,
    wis: 11,
    cha: 6,
    senses: ["blindsight 60 ft. (blind beyond this radius)"],
    passive: 10,
    immune: ["poison"],
    conditionImmune: ["poisoned"],
    languages: ["telepathy 60 ft."],
    cr: "2",
    trait: [
      {
        name: "Alternate Forms",
        entries: [
          "The gingwatzim has two alternate forms, both of which are chosen by its creator when the gingwatzim comes into being. One form is an exact duplicate of a Tiny nonmagical object (such as a book, dagger, or gemstone) that its creator is carrying or wearing when the gingwatzim is conjured. The other form can be any Tiny beast. Once these alternate forms are chosen, they can't be changed.",
        ],
      },
    ],
    action: [
      {
        name: "Energy Drain (True Form Only)",
        entries: [
          "{@atk mw} {@hit 4} to hit, reach 5 ft., one creature. {@h}16 ({@damage 4d6 + 2}) necrotic damage, and the target must succeed on a {@dc 12} Constitution saving throw or gain 1 level of {@condition exhaustion}. When the target finishes a short or long rest, the target loses every level of {@condition exhaustion} gained from this attack.",
        ],
      },
      {
        name: "Change Shape",
        entries: [
          "The gingwatzim changes from its true form\u2014a 3-foot-diameter sphere of luminous ectoplasm\u2014into one of its two alternate forms, or from one of those forms back into its true form. In object form, it can't move or make attacks but otherwise retains its statistics, and it is indistinguishable from the thing it is imitating. In beast form, it retains its hit points but otherwise uses the stat block of the beast it is imitating. When it dies, the gingwatzim reverts to its true form and then vanishes.",
        ],
      },
    ],
    senseTags: ["B"],
    actionTags: ["Shapechanger"],
    languageTags: ["TP"],
    damageTags: ["N"],
    miscTags: ["MW"],
    conditionInflict: ["exhaustion"],
    hasToken: true,
    hasFluff: true,
  },
  {
    name: "Grippli Warrior",
    source: "CM",
    page: 99,
    size: ["S"],
    type: {
      type: "humanoid",
      tags: ["grippli"],
    },
    ac: [12],
    hp: {
      average: 13,
      formula: "3d6 + 3",
    },
    speed: {
      walk: 30,
      climb: 30,
      swim: 30,
    },
    str: 10,
    dex: 15,
    con: 12,
    int: 10,
    wis: 14,
    cha: 10,
    skill: {
      athletics: "+2",
      stealth: "+4",
      survival: "+4",
    },
    passive: 12,
    languages: [
      "Grippli plus one other language (usually Common, Draconic, or Primordial)",
    ],
    cr: "1/4",
    trait: [
      {
        name: "Hold Breath",
        entries: ["The grippli can hold its breath for 20 minutes."],
      },
      {
        name: "Standing Leap",
        entries: [
          "The grippli can leap 30 feet horizontally or 20 feet vertically from a standing position.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: [
          "The grippli makes one attack with its tongue. If this attack hits, the grippli can make a melee attack using its trident against the same target.",
        ],
      },
      {
        name: "Tongue",
        entries: [
          "{@atk mw} {@hit 4} to hit, reach 5 ft., one Medium or smaller creature. {@h}The target is {@condition grappled} (escape {@dc 12}). Until this grapple ends, the target is {@condition restrained}, and the grippli can't grab another creature.",
        ],
      },
      {
        name: "Trident",
        entries: [
          "{@atk mw,rw} {@hit 4} to hit, reach 5 ft. or range 20/60 ft., one target. {@h}5 ({@damage 1d6 + 2}) piercing damage, or 6 ({@damage 1d8 + 2}) piercing damage if used with two hands to make a melee attack, plus 2 ({@damage 1d4}) piercing damage if the grippli had advantage on the attack roll.",
        ],
      },
      {
        name: "Shortbow",
        entries: [
          "{@atk rw} {@hit 4} to hit, range 80/320 ft., one target. {@h}5 ({@damage 1d6 + 2}) piercing damage, plus 2 ({@damage 1d4}) piercing damage if the grippli had advantage on the attack roll.",
        ],
      },
    ],
    attachedItems: ["shortbow|phb", "trident|phb"],
    traitTags: ["Hold Breath"],
    actionTags: ["Multiattack"],
    languageTags: ["C", "DR", "P", "X"],
    damageTags: ["P"],
    miscTags: ["MW", "RNG", "RW", "THW"],
    conditionInflict: ["grappled", "restrained"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Hag of the Fetid Gaze",
    source: "CM",
    page: 76,
    _copy: {
      name: "Green Hag",
      source: "MM",
      _mod: {
        spellcasting: {
          mode: "appendArr",
          items: {
            name: "Shared Spellcasting (Coven Only)",
            headerEntries: [
              "While all three members of a hag coven are within 30 feet of one another, they can each cast the following spells from the wizard's spell list but must share the spell slots among themselves:",
            ],
            spells: {
              1: {
                slots: 4,
                spells: ["{@spell charm person}", "{@spell witch bolt}"],
              },
              2: {
                slots: 3,
                spells: ["{@spell alter self}", "{@spell suggestion}"],
              },
              3: {
                slots: 3,
                spells: [
                  "{@spell dispel magic}",
                  "{@spell glyph of warding}",
                  "{@spell slow}",
                ],
              },
              4: {
                slots: 3,
                spells: ["{@spell blight}", "{@spell polymorph}"],
              },
              5: {
                slots: 2,
                spells: ["{@spell dominate person}", "{@spell seeming}"],
              },
              6: {
                slots: 1,
                spells: ["{@spell Otto's irresistible dance}"],
              },
            },
            footerEntries: [
              "For casting these spells, each hag is a 12th-level spellcaster that uses Intelligence as her spellcasting ability. The spell save DC is 12 + the hag's Intelligence modifier, and the spell attack bonus is 4 + the hag's Intelligence modifier.",
            ],
          },
        },
      },
    },
    damageTagsSpell: ["A", "B", "C", "F", "L", "N", "P", "S", "T", "Y"],
    spellcastingTags: ["CW", "I", "S"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Immortal Lotus Monk",
    source: "CM",
    page: 165,
    size: ["M"],
    type: "humanoid",
    ac: [
      {
        ac: 15,
        from: ["Unarmored Defense"],
      },
    ],
    hp: {
      average: 65,
      formula: "10d8 + 20",
    },
    speed: {
      walk: 30,
    },
    str: 12,
    dex: 16,
    con: 14,
    int: 11,
    wis: 14,
    cha: 10,
    skill: {
      acrobatics: "+6",
      perception: "+5",
      stealth: "+6",
    },
    passive: 15,
    languages: ["Common"],
    cr: "5",
    trait: [
      {
        name: "Unarmored Defense",
        entries: [
          "While the monk is wearing no armor and wielding no shield, its AC includes its Wisdom modifier.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: ["The monk makes two attacks."],
      },
      {
        name: "Force Strike",
        entries: [
          "{@atk mw} {@hit 6} to hit, reach 5 ft., one target. {@h}7 ({@damage 1d8 + 3}) force damage, and if the target is a creature, it must succeed on a {@dc 14} Dexterity saving throw or be knocked {@condition prone}.",
        ],
      },
      {
        name: "Dart",
        entries: [
          "{@atk rw} {@hit 6} to hit, range 20/60 ft., one target. {@h}5 ({@damage 1d4 + 3}) piercing damage.",
        ],
      },
    ],
    attachedItems: ["dart|phb"],
    actionTags: ["Multiattack"],
    languageTags: ["C"],
    damageTags: ["O", "P"],
    miscTags: ["MW", "RW", "THW"],
    conditionInflict: ["prone"],
    hasToken: true,
  },
  {
    name: "Jade Tigress",
    isNpc: true,
    isNamedCreature: true,
    source: "CM",
    page: 166,
    size: ["M"],
    type: {
      type: "humanoid",
      tags: ["human"],
    },
    alignment: ["L", "E"],
    ac: [
      {
        ac: 15,
        from: ["Unarmored Defense"],
      },
    ],
    hp: {
      average: 71,
      formula: "11d8 + 21",
    },
    speed: {
      walk: 40,
    },
    str: 18,
    dex: 14,
    con: 15,
    int: 11,
    wis: 16,
    cha: 11,
    save: {
      str: "+7",
      con: "+5",
    },
    skill: {
      athletics: "+7",
      insight: "+6",
      intimidation: "+3",
      perception: "+6",
    },
    passive: 16,
    resist: ["poison"],
    conditionImmune: ["charmed", "frightened"],
    languages: ["Common"],
    cr: "8",
    trait: [
      {
        name: "Unarmored Defense",
        entries: [
          "While Jade Tigress is wearing no armor and wielding no shield, her AC includes her Wisdom modifier.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: ["Jade Tigress makes three attacks."],
      },
      {
        name: "Force Strike",
        entries: [
          "{@atk mw} {@hit 7} to hit, reach 5 ft., one target. {@h}13 ({@damage 2d8 + 4}) force damage, and if the target is a creature, it must succeed on a {@dc 15} Constitution saving throw or be {@condition stunned} until the end of Jade Tigress's next turn.",
        ],
      },
      {
        name: "Poisoned Dart",
        entries: [
          "{@atk rw} {@hit 5} to hit, range 20/60 ft., one target. {@h}4 ({@damage 1d4 + 2}) piercing damage plus 7 ({@damage 3d4}) poison damage, and the target must succeed on a {@dc 15} Constitution saving throw or gain 1 level of {@condition exhaustion}.",
        ],
      },
      {
        name: "Heal Self (Recharges after a Long Rest)",
        entries: [
          "Jade Tigress regains {@dice 2d8 + 2} hit points, and all levels of {@condition exhaustion} end on her.",
        ],
      },
    ],
    bonus: [
      {
        name: "Nimble Escape",
        entries: ["Jade Tigress takes the Disengage or Hide action."],
      },
    ],
    reaction: [
      {
        name: "Deflect Missile",
        entries: [
          "In response to being hit by a ranged weapon attack, Jade Tigress deflects the missile. The damage she takes from the attack is reduced by {@dice 1d10 + 9}. If the damage is reduced to 0, Jade Tigress catches the missile if it's small enough to hold in one hand and Jade Tigress has a hand free.",
        ],
      },
    ],
    actionTags: ["Multiattack"],
    languageTags: ["C"],
    damageTags: ["I", "O", "P"],
    miscTags: ["MW", "RW", "THW"],
    conditionInflict: ["exhaustion", "stunned"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "K'Tulah",
    isNpc: true,
    isNamedCreature: true,
    source: "CM",
    page: 64,
    size: ["M"],
    type: {
      type: "humanoid",
      tags: ["tabaxi"],
    },
    alignment: ["N", "G"],
    ac: [11],
    hp: {
      average: 27,
      formula: "5d8 + 5",
    },
    speed: {
      walk: 30,
    },
    str: 10,
    dex: 12,
    con: 13,
    int: 12,
    wis: 15,
    cha: 11,
    skill: {
      medicine: "+4",
      nature: "+3",
      perception: "+4",
    },
    senses: ["darkvision 60 ft."],
    passive: 14,
    languages: ["Common", "Druidic"],
    cr: "2",
    spellcasting: [
      {
        name: "Spellcasting",
        headerEntries: [
          "K'Tulah is a 4th-level spellcaster. K'Tulah's spellcasting ability is Wisdom (spell save {@dc 12}, {@hit 4} to hit with spell attacks). K'Tulah has the following druid spells prepared:",
        ],
        spells: {
          0: {
            spells: [
              "{@spell druidcraft}",
              "{@spell produce flame}",
              "{@spell shillelagh}",
            ],
          },
          1: {
            slots: 4,
            spells: [
              "{@spell entangle}",
              "{@spell longstrider}",
              "{@spell speak with animals}",
              "{@spell thunderwave}",
            ],
          },
          2: {
            slots: 3,
            spells: ["{@spell animal messenger}", "{@spell barkskin}"],
          },
        },
        ability: "wis",
      },
    ],
    trait: [
      {
        name: "Feline Agility",
        entries: [
          "When K'Tulah moves on her turn in combat, she can double her speed until the end of the turn. Once she uses this ability, K'Tulah can't use it again until she moves 0 feet on one of her turns.",
        ],
      },
    ],
    action: [
      {
        name: "Quarterstaff",
        entries: [
          "{@atk mw} {@hit 2} to hit ({@hit 4} to hit with shillelagh), reach 5 ft., one target. {@h}3 ({@damage 1d6}) bludgeoning damage, 4 ({@damage 1d8}) bludgeoning damage if wielded with two hands, or 6 ({@damage 1d8 + 2}) bludgeoning damage with shillelagh.",
        ],
      },
      {
        name: "Claws",
        entries: [
          "{@atk mw} {@hit 2} to hit, reach 5 ft., one target. {@h}2 ({@damage 1d4}) slashing damage.",
        ],
      },
    ],
    attachedItems: ["quarterstaff|phb"],
    senseTags: ["D"],
    languageTags: ["C", "DU"],
    damageTags: ["B", "S"],
    damageTagsSpell: ["F", "T"],
    spellcastingTags: ["CD"],
    miscTags: ["MW"],
    conditionInflictSpell: ["restrained"],
    hasToken: true,
    hasFluff: true,
  },
  {
    name: "Kiddywidget",
    source: "CM",
    page: 136,
    size: ["S"],
    type: "construct",
    ac: [
      {
        ac: 16,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 15,
      formula: "2d6 + 8",
    },
    speed: {
      walk: 20,
      climb: 20,
    },
    str: 6,
    dex: 14,
    con: 18,
    int: 1,
    wis: 10,
    cha: 1,
    senses: ["darkvision 60"],
    passive: 10,
    immune: ["lightning", "poison"],
    conditionImmune: [
      "blinded",
      "deafened",
      "exhaustion",
      "paralyzed",
      "petrified",
      "poisoned",
    ],
    languages: ["Skitterwidget"],
    cr: "1/2",
    trait: [
      {
        name: "Unusual Nature",
        entries: [
          "The kiddywidget doesn't require air, food, drink, or sleep.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: [
          "The kiddywidget makes two attacks: one with its bite and one with its tail.",
        ],
      },
      {
        name: "Bite",
        entries: [
          "{@atk mw} {@hit 4} to hit, reach 5 ft., one target. {@h}4 ({@damage 1d4 + 2}) piercing damage. If the target is a creature, it is {@condition grappled} by the kiddywidget (escape {@dc 8}).",
        ],
      },
      {
        name: "Tail",
        entries: [
          "{@atk mw} {@hit 4} to hit, reach 5 ft., one target. {@h}4 ({@damage 1d4 + 2}) piercing damage plus 2 ({@damage 1d4}) lightning damage.",
        ],
      },
    ],
    traitTags: ["Unusual Nature"],
    senseTags: ["D"],
    actionTags: ["Multiattack"],
    damageTags: ["L", "P"],
    miscTags: ["MW"],
    conditionInflict: ["grappled"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Lichen Lich",
    source: "CM",
    page: 223,
    size: ["M"],
    type: "undead",
    ac: [
      {
        ac: 20,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 225,
      formula: "30d8 + 90",
    },
    speed: {
      walk: 30,
    },
    str: 11,
    dex: 16,
    con: 16,
    int: 14,
    wis: 20,
    cha: 16,
    save: {
      con: "+9",
      int: "+8",
      wis: "+11",
      cha: "+9",
    },
    skill: {
      medicine: "+11",
      nature: "+14",
      perception: "+11",
      survival: "+11",
    },
    senses: ["truesight 120 ft."],
    passive: 21,
    resist: ["cold", "necrotic"],
    immune: ["poison"],
    conditionImmune: [
      "charmed",
      "exhaustion",
      "frightened",
      "paralyzed",
      "poisoned",
      "stunned",
    ],
    languages: ["Common", "Druidic", "Sylvan"],
    cr: "18",
    spellcasting: [
      {
        name: "Spellcasting",
        headerEntries: [
          "The lich casts one of the following spells using Wisdom as the spellcasting ability (save {@dc 19}):",
        ],
        will: ["{@spell druidcraft}"],
        daily: {
          "3e": [
            "{@spell detect magic}",
            "{@spell fog cloud}",
            "{@spell pass without trace}",
          ],
          "1e": [
            "{@spell antilife shell}",
            "{@spell dispel magic}",
            "{@spell speak with plants}",
            "{@spell transport via plants}",
            {
              entry: "{@spell fire storm}",
              hidden: true,
            },
          ],
        },
        ability: "wis",
        displayAs: "action",
      },
    ],
    trait: [
      {
        name: "Legendary Resistance (3/Day)",
        entries: [
          "If the lich fails a saving throw, it can choose to succeed instead.",
        ],
      },
      {
        name: "Rejuvenation",
        entries: [
          "If it has a phylactery, a destroyed lich gains a new body in {@dice 1d10} days, regaining all its hit points and becoming active again. The new body appears within 5 feet of the phylactery.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: ["The lich makes four attacks."],
      },
      {
        name: "Poisonous Touch",
        entries: [
          "{@atk mw} {@hit 9} to hit, reach 10 ft., one creature. {@h}17 ({@damage 5d6}) poison damage, and the target must succeed on a {@dc 19} Constitution saving throw or be {@condition poisoned} for 1 minute. The target can repeat the saving throw at the end of each of its turns, ending the effect on itself on a success.",
        ],
      },
      {
        name: "Wither",
        entries: [
          "{@atk rs} {@hit 9} to hit, range 60 ft., one target. {@h}14 ({@damage 4d6}) necrotic damage.",
        ],
      },
      {
        name: "Fire Storm (7th-Level Spell; 1/Day)",
        entries: [
          "The lich fills up to ten 10-foot cubes with fire. Every cube must be within 150 feet of the lich and occupy a space the lich can see, and each cube must have at least one face adjacent to the face of another cube. Each creature in the area must make a {@dc 19} Dexterity saving throw, taking 38 ({@damage 7d10}) fire damage on a failed save, or half as much damage on a successful one. The fire ignites flammable objects in the area that aren't being worn or carried. If the lich chooses, plant life in the area is unaffected by the spell.",
        ],
      },
    ],
    legendary: [
      {
        name: "Attack",
        entries: ["The lich makes an attack."],
      },
      {
        name: "Poison Prick (Cost 2 Actions)",
        entries: [
          "The lich targets one {@condition poisoned} creature it can see within 30 feet of it. The target must succeed on a {@dc 19} Constitution saving throw or fall {@condition unconscious} until the {@condition poisoned} condition ends on it.",
        ],
      },
      {
        name: "Sap Life (Costs 2 Actions)",
        entries: [
          "The lich targets one creature it can see within 30 feet of it. The target must succeed on a {@dc 19} Constitution saving throw or take 11 ({@damage 2d10}) necrotic damage. The lich regains a number of hit points equal to the amount of damage that the creature takes.",
        ],
      },
    ],
    legendaryGroup: {
      name: "Lichen Lich",
      source: "CM",
    },
    traitTags: ["Legendary Resistances", "Rejuvenation"],
    senseTags: ["U"],
    actionTags: ["Multiattack"],
    languageTags: ["C", "DU", "S"],
    damageTags: ["F", "I", "N"],
    damageTagsSpell: ["F"],
    spellcastingTags: ["O"],
    miscTags: ["AOE", "MW", "RCH"],
    conditionInflict: ["poisoned", "unconscious"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Lightning Golem",
    source: "CM",
    page: 129,
    size: ["M"],
    type: "construct",
    alignment: ["N"],
    ac: [9],
    hp: {
      average: 93,
      formula: "11d8 + 44",
    },
    speed: {
      walk: 30,
    },
    str: 19,
    dex: 9,
    con: 18,
    int: 6,
    wis: 10,
    cha: 5,
    senses: ["darkvision 60 ft."],
    passive: 10,
    immune: [
      "lightning",
      "poison",
      {
        immune: ["bludgeoning", "piercing", "slashing"],
        note: "from nonmagical attacks that aren't adamantine",
        cond: true,
      },
    ],
    conditionImmune: [
      "charmed",
      "exhaustion",
      "frightened",
      "paralyzed",
      "petrified",
      "poisoned",
    ],
    languages: ["understands the languages of its creator but can't speak"],
    cr: "5",
    trait: [
      {
        name: "Berserk",
        entries: [
          "Whenever the golem starts its turn with 40 hit points or fewer, roll a {@dice d6}. On a 6, the golem goes berserk. On each of its turns while berserk, the golem attacks the nearest creature it can see. If no creature is near enough to move to and attack, the golem attacks an object, with preference for an object smaller than itself. Once the golem goes berserk, it continues to do so until it is destroyed or regains all its hit points.",
          "The golem's creator, if within 60 feet of the berserk golem, can try to calm it by speaking firmly and persuasively. The golem must be able to hear its creator, who must take an action to make a {@dc 15} Charisma (Persuasion) check. If the check succeeds, the golem ceases being berserk. If it takes damage while still at 40 hit points or fewer, the golem might go berserk again.",
        ],
      },
      {
        name: "Immutable Form",
        entries: [
          "The golem is immune to any spell or effect that would alter its form.",
        ],
      },
      {
        name: "Lightning Absorption",
        entries: [
          "Whenever the golem is subjected to lightning damage, it takes no damage and instead regains a number of hit points equal to the lightning damage dealt.",
        ],
      },
      {
        name: "Magic Resistance",
        entries: [
          "The golem has advantage on saving throws against spells and other magical effects.",
        ],
      },
      {
        name: "Magic Weapons",
        entries: ["The golem's weapon attacks are magical."],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: ["The golem makes two slam attacks."],
      },
      {
        name: "Slam",
        entries: [
          "{@atk mw} {@hit 7} to hit, reach 5 ft., one target. {@h}13 ({@damage 2d8 + 4}) lightning damage.",
        ],
      },
    ],
    traitTags: [
      "Damage Absorption",
      "Immutable Form",
      "Magic Resistance",
      "Magic Weapons",
    ],
    senseTags: ["D"],
    actionTags: ["Multiattack"],
    languageTags: ["CS"],
    damageTags: ["L"],
    miscTags: ["MW"],
    hasToken: true,
    hasFluff: true,
  },
  {
    name: "Master Sage",
    source: "CM",
    page: 9,
    size: ["M"],
    type: {
      type: "humanoid",
      tags: ["any race"],
    },
    ac: [10],
    hp: {
      average: 54,
      formula: "12d8",
    },
    speed: {
      walk: 30,
    },
    str: 8,
    dex: 10,
    con: 10,
    int: 20,
    wis: 18,
    cha: 11,
    skill: {
      arcana: "+11",
      history: "+11",
      insight: "+7",
      investigation: "+11",
      medicine: "+10",
      nature: "+11",
      religion: "+11",
    },
    passive: 14,
    languages: ["Common plus any five languages"],
    cr: "5",
    spellcasting: [
      {
        name: "Spellcasting",
        headerEntries: [
          "The sage casts one of the following spells, using Intelligence as the spellcasting ability (save {@dc 14}, {@hit 6} to hit with spell attacks):",
        ],
        will: [
          "{@spell light}",
          "{@spell mage hand}",
          "{@spell mending}",
          "{@spell prestidigitation}",
          {
            entry: "{@spell shocking grasp}",
            hidden: true,
          },
        ],
        daily: {
          "3e": [
            "{@spell comprehend languages}",
            "{@spell detect magic}",
            "{@spell dispel magic}",
            {
              entry: "{@spell fireball}",
              hidden: true,
            },
            "{@spell identify}",
            "{@spell levitate}",
            "{@spell locate object}",
            {
              entry: "{@spell shield}",
              hidden: true,
            },
            "{@spell Tenser's Floating Disk}",
            "{@spell unseen servant}",
          ],
          "1e": [
            "{@spell banishment}",
            "{@spell contact other plane}",
            "{@spell Drawmij's instant summons}",
            "{@spell legend lore}",
            "{@spell locate creature}",
            "{@spell planar binding}",
            "{@spell polymorph}",
            "{@spell protection from evil and good}",
            "{@spell scrying}",
            "{@spell sending}",
            "{@spell true seeing}",
          ],
        },
        ability: "int",
        displayAs: "action",
      },
    ],
    action: [
      {
        name: "Shocking Grasp (Cantrip)",
        entries: [
          "{@atk ms} {@hit 8} to hit (with advantage if the target is wearing armor made of metal), reach 5 ft., one creature. {@h}13 ({@damage 3d8}) lightning damage, and the target can't take reactions until the start of its next turn.",
        ],
      },
      {
        name: "Fireball (3rd-Level Spell; 3/Day)",
        entries: [
          "The sage creates a fiery explosion centered on a point it can see within 150 feet of it. Each creature in a 20-foot-radius sphere centered on that point must make a {@dc 14} Dexterity saving throw, taking 28 ({@damage 8d6}) fire damage on a failed save, or half as much damage on a successful one. The fire spreads around corners and ignites flammable objects in the area that aren't being worn or carried.",
        ],
      },
    ],
    reaction: [
      {
        name: "Shield (1st-Level Spell; 3/Day)",
        entries: [
          "When the sage is hit by an attack or targeted by a {@spell magic missile} spell, it calls forth an {@condition invisible} barrier of magical force that protects it. Until the start of its next turn, the sage has a +5 bonus to AC, including against the triggering attack, and it takes no damage from magic missile.",
        ],
      },
    ],
    languageTags: ["C", "X"],
    damageTags: ["F", "L"],
    damageTagsSpell: ["F", "L", "Y"],
    spellcastingTags: ["O"],
    miscTags: ["AOE"],
    conditionInflictSpell: ["incapacitated"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Miirym",
    isNpc: true,
    isNamedCreature: true,
    source: "CM",
    page: 16,
    size: ["L"],
    type: "undead",
    ac: [10],
    hp: {
      average: 262,
      formula: "25d10 + 125",
    },
    speed: {
      walk: 0,
      fly: {
        number: 60,
        condition: "(hover)",
      },
      canHover: true,
    },
    str: 17,
    dex: 10,
    con: 20,
    int: 18,
    wis: 15,
    cha: 23,
    save: {
      dex: "+7",
      con: "+12",
      int: "+11",
      wis: "+9",
      cha: "+13",
    },
    skill: {
      arcana: "+11",
      history: "+11",
      perception: "+16",
      stealth: "+14",
    },
    senses: [
      "blindsight 60 ft.",
      'darkvision 120 ft.; see also "x-ray vision" below',
    ],
    passive: 26,
    resist: ["acid", "fire", "lightning", "thunder"],
    immune: ["cold", "necrotic", "poison"],
    conditionImmune: [
      "charmed",
      "exhaustion",
      "frightened",
      "grappled",
      "paralyzed",
      "poisoned",
      "prone",
      "restrained",
    ],
    languages: ["Common", "Draconic"],
    cr: "22",
    spellcasting: [
      {
        name: "Spellcasting",
        headerEntries: [
          "Miirym casts one of the following spells, using Charisma as the spellcasting ability (save {@dc 21}) and requiring no material components:",
        ],
        will: ["{@spell dancing lights}", "{@spell mage hand}"],
        daily: {
          "3e": [
            "{@spell detect magic}",
            "{@spell detect thoughts}",
            "{@spell dispel magic}",
            "{@spell locate creature}",
          ],
          "1e": ["{@spell dispel evil and good}", "{@spell wall of force}"],
        },
        ability: "cha",
        displayAs: "action",
      },
    ],
    trait: [
      {
        name: "Bound to Candlekeep",
        entries: [
          "Miirym can't leave Candlekeep and is immune to any effect that would place her in a location outside it, including an extradimensional space. If she dies, Miirym regains her form and all her hit points after {@dice 1d10} days, reappearing in the location where she died or in the nearest unoccupied space.",
        ],
      },
      {
        name: "Regeneration",
        entries: [
          "Miirym regains 40 hit points at the start of her turn. If Miirym takes damage from a magic weapon or a spell, this trait doesn't function at the start of Miirym's next turn. Miirym dies only if she starts her turn with 0 hit points and doesn't regenerate.",
        ],
      },
      {
        name: "Incorporeal Movement",
        entries: [
          "Miirym can move through other creatures and objects as if they were {@quickref difficult terrain||3}. She takes 5 ({@damage 1d10}) force damage if she ends her turn inside an object.",
        ],
      },
      {
        name: "Legendary Resistance (3/Day)",
        entries: [
          "If Miirym fails a saving throw, she can choose to succeed instead.",
        ],
      },
      {
        name: "X-Ray Vision",
        entries: [
          "Miirym can see through solid matter out to a range of 60 feet. To her, opaque creatures, objects, and obstacles within that distance appear transparent and don't prevent light from passing through them. This vision can penetrate 5 feet of stone, 3 inches of common metal, and up to 10 feet of wood or dirt. Thicker substances block this vision, as does a thin sheet of lead.",
        ],
      },
    ],
    action: [
      {
        name: "Bite",
        entries: [
          "{@atk mw} {@hit 10} to hit, reach 5 ft., one target. {@h}34 ({@damage 9d6 + 3}) force damage.",
        ],
      },
      {
        name: "Breath Weapon {@recharge 5}",
        entries: ["Miirym uses one of the following breath weapons:"],
      },
      {
        name: "Cold Breath",
        entries: [
          "Miirym exhales an icy blast in a 90-foot cone. Each creature in that area must make a {@dc 21} Constitution saving throw, taking 67 ({@damage 15d8}) cold damage on a failed save, or half as much damage on a successful one.",
        ],
      },
      {
        name: "Necrotic Breath",
        entries: [
          "Miirym exhales a bolt of necrotic energy in a 120-foot line that is 10 feet wide. Each creature in that line must make a {@dc 21} Dexterity saving throw, taking 82 ({@damage 15d10}) necrotic damage on a failed save, or half as much damage on a successful one.",
        ],
      },
      {
        name: "Paralyzing Breath",
        entries: [
          "Miirym exhales paralyzing gas in a 90-foot cone. Each creature in that area must succeed on a {@dc 21} Constitution saving throw or be {@condition paralyzed} for 1 minute. A creature can repeat the saving throw at the end of each of its turns, ending the effect on itself on a success.",
        ],
      },
      {
        name: "Frightful Presence",
        entries: [
          "Each creature of Miirym's choice that is within 120 feet of her and aware of her must succeed on a {@dc 21} Wisdom saving throw or become {@condition frightened} for 1 minute. A creature can repeat the saving throw at the end of each of its turns, ending the effect on itself on a success. If a creature's saving throw is successful or the effect ends for it, the creature is immune to Miirym's Frightful Presence for the next 24 hours.",
        ],
      },
    ],
    legendary: [
      {
        name: "Bite",
        entries: ["Miirym makes a bite attack."],
      },
      {
        name: "Teleport (Costs 2 Actions)",
        entries: [
          "Miirym magically teleports up to 120 feet to an unoccupied space she can see.",
        ],
      },
    ],
    traitTags: [
      "Incorporeal Movement",
      "Legendary Resistances",
      "Regeneration",
    ],
    senseTags: ["B", "SD"],
    actionTags: ["Breath Weapon", "Frightful Presence"],
    languageTags: ["C", "DR"],
    damageTags: ["C", "N", "O"],
    spellcastingTags: ["O"],
    miscTags: ["AOE", "MW"],
    conditionInflict: ["frightened", "paralyzed"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Mimic Chair",
    source: "CM",
    page: 22,
    size: ["M"],
    type: {
      type: "monstrosity",
      tags: ["shapechanger"],
    },
    alignment: ["N"],
    ac: [
      {
        ac: 12,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 30,
      formula: "9d8 + 18",
    },
    speed: {
      walk: 15,
    },
    str: 17,
    dex: 12,
    con: 15,
    int: 5,
    wis: 13,
    cha: 8,
    skill: {
      stealth: "+5",
    },
    senses: ["darkvision 60 ft."],
    passive: 11,
    immune: ["acid"],
    conditionImmune: ["prone"],
    cr: "2",
    trait: [
      {
        name: "Shapechanger",
        entries: [
          "The mimic can use its action to polymorph into an object or back into its true, amorphous form. Its statistics are the same in each form. Any equipment it is wearing or carrying isn't transformed. It reverts to its true form if it dies.",
        ],
      },
      {
        name: "Adhesive (Object Form Only)",
        entries: [
          "The mimic adheres to anything that touches it. A Huge or smaller creature adhered to the mimic is also {@condition grappled} by it (escape {@dc 10}). Ability checks made to escape this grapple have disadvantage.",
        ],
      },
      {
        name: "False Appearance (Object Form Only)",
        entries: [
          "While the mimic remains motionless, it is indistinguishable from an ordinary object.",
        ],
      },
      {
        name: "Grappler",
        entries: [
          "The mimic has advantage on attack rolls against any creature {@condition grappled} by it.",
        ],
      },
    ],
    action: [
      {
        name: "Pseudopod",
        entries: [
          "{@atk mw} {@hit 5} to hit, reach 5 ft., one target. {@h}7 ({@damage 1d8 + 3}) bludgeoning damage. If the mimic is in object form, the target is subjected to its Adhesive trait.",
        ],
      },
      {
        name: "Bite",
        entries: [
          "{@atk mw} {@hit 5} to hit, reach 5 ft., one target. {@h}7 ({@damage 1d8 + 3}) piercing damage plus 4 ({@damage 1d8}) acid damage.",
        ],
      },
    ],
    traitTags: ["False Appearance", "Shapechanger"],
    senseTags: ["D"],
    damageTags: ["A", "B", "P"],
    miscTags: ["MW"],
    conditionInflict: ["grappled"],
    hasToken: true,
  },
  {
    name: "Naiad",
    source: "CM",
    page: 84,
    _copy: {
      name: "Naiad",
      source: "MOT",
    },
    hasToken: true,
    hasFluffImages: true,
  },
  {
    name: "Nintra Siotta",
    isNpc: true,
    isNamedCreature: true,
    source: "CM",
    page: 197,
    size: ["L"],
    type: "fey",
    alignment: ["C", "E"],
    ac: [17],
    hp: {
      average: 306,
      formula: "36d10 + 108",
    },
    speed: {
      walk: 40,
      fly: {
        number: 40,
        condition: "(hover)",
      },
      canHover: true,
    },
    str: 16,
    dex: 24,
    con: 16,
    int: 17,
    wis: 15,
    cha: 24,
    save: {
      str: "+8",
      dex: "+12",
      wis: "+7",
    },
    skill: {
      deception: "+12",
      insight: "+7",
      perception: "+7",
    },
    senses: ["truesight 60 ft."],
    passive: 17,
    conditionImmune: ["charmed", "exhaustion", "stunned"],
    languages: ["Common", "Elvish", "Sylvan"],
    cr: "16",
    spellcasting: [
      {
        name: "Spellcasting",
        headerEntries: [
          "Nintra casts one of the following spells, using Charisma as the spellcasting ability (save {@dc 20}) and requiring no material components:",
        ],
        daily: {
          "3e": [
            "{@spell dispel magic}",
            "{@spell faerie fire}",
            "{@spell mirror image}",
          ],
        },
        ability: "cha",
        displayAs: "action",
      },
    ],
    trait: [
      {
        name: "Legendary Resistance (3/Day)",
        entries: [
          "If Nintra fails a saving throw, she can choose to succeed instead.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: ["Nintra makes two attacks."],
      },
      {
        name: "Claw",
        entries: [
          "{@atk mw} {@hit 12} to hit, reach 5 ft., one target. {@h}12 ({@damage 2d4 + 7}) piercing damage.",
        ],
      },
      {
        name: "Shard of Shadow",
        entries: [
          "{@atk rs} {@hit 12} to hit, range 120 ft., one target. {@h}10 ({@damage 1d6 + 7}) necrotic damage, and if the target is a creature, it must succeed on a {@dc 20} Constitution saving throw or be {@condition poisoned} until the end of its next turn.",
        ],
      },
      {
        name: "Storm of Shattered Glass {@recharge}",
        entries: [
          "Nintra targets a point she can see within 60 feet of her and creates a 20-foot-radius sphere of swirling glass shards centered on that point. Each creature in the sphere must make a {@dc 20} Dexterity saving throw, taking 28 ({@damage 8d6}) slashing damage on a failed save, or half as much damage on a successful save. If Nintra is in the sphere, the shards deal no damage to her.",
        ],
      },
    ],
    legendary: [
      {
        name: "Attack",
        entries: ["Nintra makes one attack."],
      },
      {
        name: "Fey Step",
        entries: [
          "Nintra teleports to an unoccupied space she can see within 30 feet of her.",
        ],
      },
      {
        name: "Shadow Strikes (Costs 2 Actions)",
        entries: [
          "Provided she is in bright or dim light, Nintra causes her shadow to attack a creature within 10 feet of her. Her shadow makes two claw attacks, each attack identical to Nintra's claw attack except that it deals psychic damage instead of piercing damage.",
        ],
      },
    ],
    legendaryGroup: {
      name: "Nintra Siotta",
      source: "CM",
    },
    traitTags: ["Legendary Resistances"],
    senseTags: ["U"],
    actionTags: ["Multiattack"],
    languageTags: ["C", "E", "S"],
    damageTags: ["N", "P", "S"],
    damageTagsLegendary: ["N", "P"],
    spellcastingTags: ["O"],
    miscTags: ["AOE", "MW"],
    conditionInflict: ["poisoned"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Parasite-infested Behir",
    source: "CM",
    page: 220,
    size: ["H"],
    type: "undead",
    alignment: ["N", "E"],
    ac: [
      {
        ac: 17,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 168,
      formula: "16d12 + 64",
    },
    speed: {
      walk: 50,
      climb: 40,
    },
    str: 23,
    dex: 16,
    con: 18,
    int: 7,
    wis: 14,
    cha: 12,
    skill: {
      perception: "+6",
      stealth: "+7",
    },
    senses: ["darkvision 90 ft."],
    passive: 16,
    immune: ["lightning"],
    languages: ["Draconic"],
    cr: "11",
    action: [
      {
        name: "Multiattack",
        entries: [
          "The behir makes two attacks: one with its bite and one to constrict.",
        ],
      },
      {
        name: "Bite",
        entries: [
          "{@atk mw} {@hit 10} to hit, reach 10 ft., one target. {@h}22 ({@damage 3d10 + 6}) piercing damage.",
        ],
      },
      {
        name: "Constrict",
        entries: [
          "{@atk mw} {@hit 10} to hit, reach 5 ft., one Large or smaller creature. {@h}17 ({@damage 2d10 + 6}) bludgeoning damage plus 17 ({@damage 2d10 + 6}) slashing damage. The target is {@condition grappled} (escape {@dc 16}) if the behir isn't already constricting a creature, and the target is {@condition restrained} until this grapple ends.",
        ],
      },
      {
        name: "Lightning Breath {@recharge 5}",
        entries: [
          "The behir exhales a line of lightning that is 20 feet long and 5 feet wide. Each creature in that line must make a {@dc 16} Dexterity saving throw, taking 66 ({@damage 12d10}) lightning damage on a failed save, or half as much damage on a successful one.",
        ],
      },
      {
        name: "Swallow",
        entries: [
          "The behir makes one bite attack against a Medium or smaller target it is grappling. If the attack hits, the target is also swallowed, and the grapple ends. While swallowed, the target is {@condition blinded} and {@condition restrained}, it has total cover against attacks and other effects outside the behir, and it takes 21 ({@damage 6d6}) acid damage at the start of each of the behir's turns. A behir can have only one creature swallowed at a time.",
          "Any creature swallowed by a parasite-infested behir must succeed on a {@dc 19} Constitution saving throw at the start of each of the behir's turns or be feasted upon by blood parasites, taking 36 ({@damage 8d8}) necrotic damage on a failed save, or half as much damage on a successful save. This damage is in addition to the damage caused by the behir's digestive acids.",
          "If the behir takes 30 damage or more on a single turn from the swallowed creature, the behir must succeed on a {@dc 14} Constitution saving throw at the end of that turn or regurgitate the creature, which falls {@condition prone} in a space within 10 feet of the behir. If the behir dies, a swallowed creature is no longer {@condition restrained} by it and can escape from the corpse by using 15 feet of movement, exiting {@condition prone}.",
        ],
      },
    ],
    senseTags: ["D"],
    actionTags: ["Breath Weapon", "Multiattack", "Swallow"],
    languageTags: ["DR"],
    damageTags: ["A", "B", "L", "N", "P", "S"],
    miscTags: ["MW", "RCH"],
    conditionInflict: ["blinded", "grappled", "restrained"],
    hasToken: true,
    hasFluff: true,
  },
  {
    name: "Ram Sugar",
    isNpc: true,
    isNamedCreature: true,
    source: "CM",
    page: 132,
    size: ["M"],
    type: {
      type: "humanoid",
      tags: ["dragonborn"],
    },
    alignment: ["C", "N"],
    ac: [
      {
        ac: 13,
        from: ["{@item leather armor|PHB}"],
      },
    ],
    hp: {
      average: 33,
      formula: "6d8 + 6",
    },
    speed: {
      walk: 30,
    },
    str: 11,
    dex: 14,
    con: 12,
    int: 10,
    wis: 13,
    cha: 14,
    skill: {
      deception: "+4",
      persuasion: "+4",
      religion: "+2",
    },
    passive: 11,
    resist: ["fire"],
    languages: ["Common", "Draconic"],
    cr: "2",
    spellcasting: [
      {
        name: "Spellcasting",
        headerEntries: [
          "Ram Sugar is a 4th-level spellcaster. Its spellcasting ability is Wisdom (spell save {@dc 11}, {@hit 3} to hit with spell attacks). Ram Sugar has the following cleric spells prepared:",
        ],
        spells: {
          0: {
            spells: [
              "{@spell light}",
              "{@spell sacred flame}",
              "{@spell thaumaturgy}",
            ],
          },
          1: {
            slots: 4,
            spells: [
              "{@spell command}",
              "{@spell inflict wounds}",
              "{@spell shield of faith}",
            ],
          },
          2: {
            slots: 3,
            spells: ["{@spell hold person}", "{@spell spiritual weapon}"],
          },
        },
        ability: "wis",
      },
    ],
    trait: [
      {
        name: "Dark Devotion",
        entries: [
          "Ram Sugar has advantage on saving throws against being {@condition charmed} or {@condition frightened}.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: ["Ram Sugar makes two melee attacks."],
      },
      {
        name: "Dagger",
        entries: [
          "{@atk mw,rw} {@hit 4} to hit, reach 5 ft. or range 20/60 ft., one creature. {@h}4 ({@damage 1d4 + 2}) piercing damage.",
        ],
      },
      {
        name: "Breath Weapon (Recharges after a Short or Long Rest)",
        entries: [
          "Ram Sugar exhales fire in a 30-foot-long line that is 5 feet wide. Any creature in the line must make a {@dc 11} Dexterity saving throw, taking 7 ({@damage 2d6}) fire damage on a failed save, or half as much damage on a successful one.",
        ],
      },
    ],
    attachedItems: ["dagger|phb"],
    actionTags: ["Breath Weapon", "Multiattack"],
    languageTags: ["C", "DR"],
    damageTags: ["F", "P"],
    damageTagsSpell: ["N", "O", "R"],
    spellcastingTags: ["CC"],
    miscTags: ["MW", "RW", "THW"],
    conditionInflictSpell: ["paralyzed", "prone"],
    hasToken: true,
    hasFluff: true,
  },
  {
    name: "Sage",
    source: "CM",
    page: 9,
    size: ["M"],
    type: {
      type: "humanoid",
      tags: ["any race"],
    },
    ac: [10],
    hp: {
      average: 22,
      formula: "5d8",
    },
    speed: {
      walk: 30,
    },
    str: 8,
    dex: 10,
    con: 10,
    int: 18,
    wis: 15,
    cha: 11,
    skill: {
      arcana: "+8",
      history: "+8",
      insight: "+4",
      investigation: "+8",
      medicine: "+6",
      nature: "+8",
      religion: "+8",
    },
    passive: 12,
    languages: ["Common plus any four languages"],
    cr: "1/2",
    spellcasting: [
      {
        name: "Spellcasting",
        headerEntries: [
          "The sage casts one of the following spells, using Intelligence as the spellcasting ability (save {@dc 14}, {@hit 6} to hit with spell attacks):",
        ],
        will: [
          "{@spell light}",
          "{@spell mage hand}",
          "{@spell mending}",
          {
            entry: "{@spell shocking grasp}",
            hidden: true,
          },
        ],
        daily: {
          "3e": [
            "{@spell comprehend languages}",
            "{@spell detect magic}",
            "{@spell identify}",
            {
              entry: "{@spell shield}",
              hidden: true,
            },
          ],
          "1e": [
            "{@spell dispel magic}",
            "{@spell levitate}",
            "{@spell locate object}",
            "{@spell see invisibility}",
            "{@spell sending}",
            "{@spell tongues}",
            "{@spell unseen servant}",
          ],
        },
        ability: "int",
        displayAs: "action",
      },
    ],
    action: [
      {
        name: "Shocking Grasp (Cantrip)",
        entries: [
          "{@atk ms} {@hit 6} to hit (with advantage if the target is wearing armor made of metal), reach 5 ft., one creature. {@h}9 ({@damage 2d8}) lightning damage, and the target can't take reactions until the start of its next turn.",
        ],
      },
    ],
    reaction: [
      {
        name: "Shield (1st-Level Spell; 3/Day)",
        entries: [
          "When the sage is hit by an attack or targeted by a {@spell magic missile} spell, it calls forth an {@condition invisible} barrier of magical force that protects it. Until the start of its next turn, the sage has a +5 bonus to AC, including against the triggering attack, and it takes no damage from magic missile.",
        ],
      },
    ],
    languageTags: ["C", "X"],
    damageTags: ["L"],
    damageTagsSpell: ["L"],
    spellcastingTags: ["O"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Sapphire Sentinel",
    source: "CM",
    page: 201,
    size: ["L"],
    type: "construct",
    alignment: ["U"],
    ac: [
      {
        ac: 17,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 178,
      formula: "17d10 + 85",
    },
    speed: {
      walk: 30,
    },
    str: 22,
    dex: 9,
    con: 20,
    int: 3,
    wis: 11,
    cha: 1,
    senses: ["darkvision 120 ft."],
    passive: 10,
    immune: [
      "poison",
      "psychic",
      {
        immune: ["bludgeoning", "piercing", "slashing"],
        note: "from nonmagical attacks that aren't adamantine",
        cond: true,
      },
    ],
    conditionImmune: [
      "charmed",
      "exhaustion",
      "frightened",
      "paralyzed",
      "petrified",
      "poisoned",
    ],
    languages: ["understands Common but can't speak"],
    cr: "10",
    trait: [
      {
        name: "Immutable Form",
        entries: [
          "The golem is immune to any spell or effect that would alter its form.",
        ],
      },
      {
        name: "Magic Resistance",
        entries: [
          "The golem has advantage on saving throws against spells and other magical effects.",
        ],
      },
      {
        name: "Magic Weapons",
        entries: ["The golem's weapon attacks are magical."],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: ["The golem makes two slam attacks."],
      },
      {
        name: "Slam",
        entries: [
          "{@atk mw} {@hit 10} to hit, reach 5 ft., one target. {@h}19 ({@damage 3d8 + 6}) bludgeoning damage.",
        ],
      },
      {
        name: "Slow {@recharge 5}",
        entries: [
          "The golem targets one or more creatures it can see within 10 feet of it. Each target must make a {@dc 17} Wisdom saving throw against this magic. On a failed save, a target can't use reactions, its speed is halved, and it can't make more than one attack on its turn. In addition, the target can take either an action or a bonus action on its turn, not both. These effects last for 1 minute. A target can repeat the saving throw at the end of each of its turns, ending the effect on itself on a success.",
        ],
      },
      {
        name: "Sapphire",
        entries: [
          "The sapphire has 3 charges. As an action, the golem can expend 1 charge to cast {@spell dispel magic} (as a 9th-level spell) from the sapphire using Constitution as its spellcasting ability. The sapphire ceases to glow if all its charges are expended, but it regains {@dice 1d3} expended charges daily at dawn and glows again once it has 1 or more charges.",
        ],
      },
    ],
    traitTags: ["Immutable Form", "Magic Resistance", "Magic Weapons"],
    senseTags: ["SD"],
    actionTags: ["Multiattack"],
    languageTags: ["C", "CS"],
    damageTags: ["B"],
    miscTags: ["MW"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Shemshime",
    isNpc: true,
    isNamedCreature: true,
    source: "CM",
    page: 69,
    size: ["M"],
    type: "undead",
    ac: [13],
    hp: {
      average: 31,
      formula: "7d8",
    },
    speed: {
      walk: 0,
      fly: {
        number: 40,
        condition: "(hover)",
      },
      canHover: true,
    },
    str: 6,
    dex: 17,
    con: 10,
    int: 17,
    wis: 14,
    cha: 16,
    save: {
      int: "+5",
      wis: "+4",
    },
    skill: {
      perception: "+4",
      stealth: "+7",
    },
    senses: ["darkvision 120 ft."],
    passive: 14,
    resist: [
      "acid",
      "bludgeoning",
      "fire",
      "lightning",
      "piercing",
      "slashing",
      "thunder",
    ],
    immune: ["cold", "necrotic", "poison"],
    conditionImmune: [
      "charmed",
      "exhaustion",
      "frightened",
      "grappled",
      "paralyzed",
      "petrified",
      "poisoned",
      "prone",
      "restrained",
    ],
    languages: ["telepathy 60 ft."],
    cr: "4",
    trait: [
      {
        name: "Crushing End",
        entries: [
          "If damage reduces Shemshime to 0 hit points, Shemshime instead drops to 1 hit point unless the damage is the result of Shemshime being crushed by an object weighing at least 1,000 pounds.",
        ],
      },
      {
        name: "Incorporeal Movement",
        entries: [
          "Shemshime can move through other creatures and objects as if they were {@quickref difficult terrain||3}. It takes 5 ({@damage 1d10}) force damage if it ends its turn inside an object.",
        ],
      },
    ],
    action: [
      {
        name: "Maddening Touch",
        entries: [
          "{@atk ms} {@hit 5} to hit, reach 5 ft., one target. {@h}17 ({@damage 4d6 + 3}) psychic damage.",
        ],
      },
      {
        name: "Whispers of Violence",
        entries: [
          "Shemshime chooses up to two creatures it can see within 60 feet of it. Each target must succeed on a {@dc 13} Wisdom saving throw, or that target takes 7 ({@damage 1d8 + 3}) psychic damage and must use its reaction to make a melee weapon attack against one creature it can reach (Shemshime's choice) that Shemshime can see.",
        ],
      },
      {
        name: "Howling Babble {@recharge}",
        entries: [
          "Shemshime targets one creature it can see within 30 feet of it. The creature must make a {@dc 13} Wisdom saving throw. On a failed save, it takes 21 ({@damage 4d8 + 3}) psychic damage and is {@condition stunned} until the end of its next turn. On a successful save, it takes half as much damage and isn't {@condition stunned}.",
        ],
      },
    ],
    traitTags: ["Incorporeal Movement"],
    senseTags: ["SD"],
    languageTags: ["TP"],
    damageTags: ["O", "Y"],
    hasToken: true,
    hasFluffImages: true,
  },
  {
    name: "Skitterwidget",
    source: "CM",
    page: 136,
    size: ["M"],
    type: "construct",
    ac: [
      {
        ac: 18,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 85,
      formula: "10d8 + 40",
    },
    speed: {
      walk: 30,
      climb: 30,
    },
    str: 16,
    dex: 14,
    con: 18,
    int: 3,
    wis: 10,
    cha: 1,
    senses: ["darkvision 60 ft."],
    passive: 10,
    immune: ["lightning", "poison"],
    conditionImmune: [
      "blinded",
      "deafened",
      "exhaustion",
      "paralyzed",
      "petrified",
      "poisoned",
    ],
    languages: ["Skitterwidget"],
    cr: "5",
    trait: [
      {
        name: "Lightning Absorption",
        entries: [
          "Whenever the skitterwidget is subjected to lightning damage, it takes no damage and instead regains a number of hit points equal to the lightning damage dealt.",
        ],
      },
      {
        name: "Unusual Nature",
        entries: [
          "The skitterwidget doesn't require air, food, drink, or sleep.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: [
          "The skitterwidget makes two attacks: one with its bite and one with its tail.",
        ],
      },
      {
        name: "Bite",
        entries: [
          "{@atk mw} {@hit 6} to hit, reach 5 ft., one target. {@h}10 ({@damage 2d6 + 3}) piercing damage. If the target is a creature, it is {@condition grappled} by the skitterwidget (escape {@dc 13}).",
        ],
      },
      {
        name: "Tail",
        entries: [
          "{@atk mw} {@hit 6} to hit, reach 5 ft., one target. {@h}6 ({@damage 1d6 + 3}) piercing damage plus 10 ({@damage 3d6}) lightning damage, and if the target is a creature, it must succeed on a {@dc 15} Constitution saving throw or be {@condition stunned} until the end of its next turn.",
        ],
      },
    ],
    reaction: [
      {
        name: "Good Parent",
        entries: [
          "The skitterwidget imposes disadvantage on one attack roll made against a kiddywidget it can see within 5 feet of it.",
        ],
      },
    ],
    traitTags: ["Damage Absorption", "Unusual Nature"],
    senseTags: ["D"],
    actionTags: ["Multiattack"],
    damageTags: ["L", "P"],
    miscTags: ["MW"],
    conditionInflict: ["grappled", "stunned"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Steel Crane",
    isNpc: true,
    isNamedCreature: true,
    source: "CM",
    page: 164,
    size: ["M"],
    type: {
      type: "humanoid",
      tags: ["human"],
    },
    alignment: ["L", "E"],
    ac: [
      {
        ac: 17,
        from: ["Unarmored Defense"],
      },
    ],
    hp: {
      average: 76,
      formula: "9d8 + 36",
    },
    speed: {
      walk: 40,
    },
    str: 13,
    dex: 18,
    con: 18,
    int: 13,
    wis: 17,
    cha: 14,
    save: {
      dex: "+7",
      int: "+4",
    },
    skill: {
      acrobatics: "+7",
      deception: "+5",
      perception: "+6",
      stealth: "+7",
    },
    passive: 16,
    resist: ["poison", "psychic"],
    languages: ["Common"],
    cr: "8",
    trait: [
      {
        name: "Unarmored Defense",
        entries: [
          "While Steel Crane is wearing no armor and wielding no shield, his AC includes his Wisdom modifier.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: ["Steel Crane makes three attacks."],
      },
      {
        name: "Force Strike",
        entries: [
          "{@atk mw} {@hit 7} to hit, reach 5 ft., one target. {@h}8 ({@damage 1d8 + 4}) force damage, and if the target is a creature, it must succeed on a {@dc 15} Constitution saving throw or be {@condition stunned} until the start of Steel Crane's next turn.",
        ],
      },
      {
        name: "Whip",
        entries: [
          "{@atk mw} {@hit 7} to hit, reach 10 ft., one target. {@h}6 ({@damage 1d4 + 4}) slashing damage or, if the target is a creature, Steel Crane can grapple the target instead (escape {@dc 15}). Steel Crane can't make attacks with the whip while using it to grapple a creature. Anytime on his turn, he can release a creature {@condition grappled} by the whip (no action required).",
        ],
      },
      {
        name: "Heal Self (Recharges after a Long Rest)",
        entries: [
          "Steel Crane regains {@dice 2d8 + 4} hit points, and all levels of {@condition exhaustion} end on him.",
        ],
      },
    ],
    reaction: [
      {
        name: "Deflect Missile",
        entries: [
          "In response to being hit by a ranged weapon attack, Steel Crane deflects the missile. The damage he takes from the attack is reduced by {@dice 1d10 + 10}. If the damage is reduced to 0, Steel Crane catches the missile if it's small enough to hold in one hand and Steel Crane has a hand free.",
        ],
      },
      {
        name: "Slow Descent (3/Day)",
        entries: [
          "When Steel Crane falls, he can slow his descent, taking no damage from the fall.",
        ],
      },
    ],
    attachedItems: ["whip|phb"],
    actionTags: ["Multiattack"],
    languageTags: ["C"],
    damageTags: ["O", "S"],
    miscTags: ["MW", "RCH"],
    conditionInflict: ["stunned"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Storm Giant Skeleton",
    source: "CM",
    page: 208,
    size: ["H"],
    type: "undead",
    ac: [
      {
        ac: 13,
        from: ["armor scraps"],
      },
    ],
    hp: {
      average: 204,
      formula: "24d12 + 48",
    },
    speed: {
      walk: 50,
    },
    str: 29,
    dex: 14,
    con: 15,
    int: 3,
    wis: 8,
    cha: 1,
    save: {
      str: "+14",
      con: "+7",
    },
    skill: {
      perception: "+4",
    },
    senses: ["darkvision 60 ft."],
    passive: 14,
    resist: ["cold"],
    immune: ["lightning", "poison", "thunder"],
    vulnerable: ["bludgeoning"],
    conditionImmune: ["exhaustion", "poisoned"],
    cr: "16",
    action: [
      {
        name: "Multiattack",
        entries: [
          "The giant makes two attacks with its greatsword or hurls two rocks.",
        ],
      },
      {
        name: "Greatsword",
        entries: [
          "{@atk mw} {@hit 14} to hit, reach 10 ft., one target. {@h}30 ({@damage 6d6 + 9}) slashing damage plus 18 ({@damage 4d8}) necrotic damage.",
        ],
      },
      {
        name: "Rock",
        entries: [
          "{@atk rw} {@hit 14} to hit, reach 60/240 ft., one target. {@h}35 ({@damage 4d12 + 9}) bludgeoning damage.",
        ],
      },
      {
        name: "Lightning Strike {@recharge 5}",
        entries: [
          "The giant hurls a magical lightning bolt at a point it can see within 500 feet of it. Each creature within 10 feet of that point must make a {@dc 15} Dexterity saving throw, taking 54 ({@damage 12d8}) lightning damage on a failed save, or half as much damage on a successful one.",
        ],
      },
    ],
    attachedItems: ["greatsword|phb"],
    senseTags: ["D"],
    actionTags: ["Multiattack"],
    damageTags: ["B", "L", "N", "S"],
    miscTags: ["AOE", "MW", "RCH", "RW"],
    hasToken: true,
  },
  {
    name: "Swarm of Animated Books",
    source: "CM",
    page: 19,
    size: ["M"],
    type: {
      type: "construct",
      swarmSize: "T",
    },
    ac: [
      {
        ac: 12,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 22,
      formula: "4d8 + 4",
    },
    speed: {
      walk: 0,
      fly: {
        number: 30,
        condition: "(hover)",
      },
      canHover: true,
    },
    str: 10,
    dex: 13,
    con: 12,
    int: 1,
    wis: 10,
    cha: 1,
    senses: ["blindsight 60 ft. (blind beyond this radius)"],
    passive: 10,
    immune: ["poison", "psychic"],
    vulnerable: ["fire"],
    conditionImmune: [
      "charmed",
      "exhaustion",
      "frightened",
      "grappled",
      "paralyzed",
      "petrified",
      "poisoned",
      "prone",
      "restrained",
      "stunned",
    ],
    cr: "1/4",
    trait: [
      {
        name: "False Objects",
        entries: [
          "If the swarm is motionless at the start of combat, it has advantage on its initiative roll. Moreover, if a creature hasn't observed the swarm move or act, that creature must succeed on a {@dc 15} Wisdom (Perception) check to discern that the swarm is animate.",
        ],
      },
      {
        name: "Swarm",
        entries: [
          "The swarm can occupy another creature's space and vice versa, and the swarm can move through any opening large enough for a 1-foot-tall, 8-inch-wide, 2-inch-thick object. The swarm can't regain hit points or gain temporary hit points.",
        ],
      },
    ],
    action: [
      {
        name: "Book Club",
        entries: [
          "{@atk mw} {@hit 3} to hit, reach 0 ft., one target in the swarm's space. {@h}6 ({@damage 2d4 + 1}) bludgeoning damage, or 3 ({@damage 1d4 + 1}) bludgeoning damage if the swarm has half its hit points or fewer.",
        ],
      },
    ],
    senseTags: ["B"],
    damageTags: ["B"],
    miscTags: ["MW"],
    hasToken: true,
    hasFluffImages: true,
  },
  {
    name: "Valin Sarnaster",
    isNpc: true,
    isNamedCreature: true,
    source: "CM",
    page: 182,
    size: ["M"],
    type: "undead",
    alignment: ["L", "E"],
    ac: [
      {
        ac: 17,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 97,
      formula: "13d8 + 39",
    },
    speed: {
      walk: 20,
    },
    str: 18,
    dex: 10,
    con: 17,
    int: 11,
    wis: 18,
    cha: 16,
    save: {
      con: "+8",
      int: "+5",
      wis: "+9",
      cha: "+8",
    },
    skill: {
      history: "+5",
      religion: "+5",
    },
    senses: ["darkvision 60 ft."],
    passive: 14,
    immune: [
      "necrotic",
      "poison",
      {
        immune: ["bludgeoning", "piercing", "slashing"],
        note: "from nonmagical attacks",
        cond: true,
      },
    ],
    vulnerable: ["fire"],
    conditionImmune: [
      "charmed",
      "exhaustion",
      "frightened",
      "paralyzed",
      "poisoned",
    ],
    languages: ["The languages it knew in life"],
    cr: "16",
    spellcasting: [
      {
        name: "Spellcasting",
        headerEntries: [
          "Valin Sarnaster is a 10th-level spellcaster. Her spellcasting ability is Wisdom (spell save {@dc 17}, {@hit 9} to hit with spell attacks). Valin has the following cleric spells prepared:",
        ],
        spells: {
          0: {
            spells: ["{@spell sacred flame}", "{@spell thaumaturgy}"],
          },
          1: {
            slots: 4,
            spells: [
              "{@spell command}",
              "{@spell guiding bolt}",
              "{@spell shield of faith}",
            ],
          },
          2: {
            slots: 3,
            spells: [
              "{@spell hold person}",
              "{@spell silence}",
              "{@spell spiritual weapon}",
            ],
          },
          3: {
            slots: 3,
            spells: ["{@spell clairvoyance}", "{@spell dispel magic}"],
          },
          4: {
            slots: 3,
            spells: ["{@spell divination}", "{@spell dimension door}"],
          },
          5: {
            slots: 2,
            spells: ["{@spell contagion}", "{@spell scrying}"],
          },
          6: {
            slots: 1,
            spells: ["{@spell harm}"],
          },
        },
        ability: "wis",
      },
    ],
    trait: [
      {
        name: "Magic Resistance",
        entries: [
          "Valin has advantage on saving throws against spells and other magical effects.",
        ],
      },
      {
        name: "Rejuvenation",
        entries: [
          "While her heart remains in Alessia's body, Valin re-forms inside her sarcophagus, regaining all her hit points and becoming active again.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: [
          "Valin can use her Dreadful Glare and makes one attack with her rotting fist.",
        ],
      },
      {
        name: "Rotting Fist",
        entries: [
          "{@atk mw} {@hit 9} to hit, reach 5 ft., one target. {@h}14 ({@damage 3d6 + 4}) bludgeoning damage plus 21 ({@damage 6d6}) necrotic damage. If the target is a creature, it must succeed on a {@dc 16} Constitution saving throw or be cursed with mummy rot. The cursed target can't regain hit points, and its hit point maximum decreases by 10 ({@dice 3d6}) for every 24 hours that elapse. If the curse reduces the target's hit point maximum to 0, the target dies, and its body turns to dust. The curse lasts until removed by the {@spell remove curse} spell or other magic.",
        ],
      },
      {
        name: "Dreadful Glare",
        entries: [
          "Valin targets one creature she can see within 60 feet of her. If the target can see Valin, it must succeed on a {@dc 16} Wisdom saving throw against this magic or become {@condition frightened} until the end of Valin's next turn. If the target fails the saving throw by 5 or more, it is also {@condition paralyzed} for the same duration. A target that succeeds on the saving throw is immune to the Dreadful Glare of all mummies and mummy lords for the next 24 hours.",
        ],
      },
    ],
    legendary: [
      {
        name: "Attack",
        entries: [
          "Valin makes one attack with her rotting fist or uses her Dreadful Glare.",
        ],
      },
      {
        name: "Blinding Dust",
        entries: [
          "Blinding dust and sand swirls magically around Valin. Each creature within 5 feet of Valin must succeed on a {@dc 16} Constitution saving throw or be {@condition blinded} until the end of her next turn.",
        ],
      },
      {
        name: "Blasphemous Word (Costs 2 Actions)",
        entries: [
          "Valin utters a blasphemous word. Each non-undead creature within 10 feet of Valin that can hear the magical utterance must succeed on a {@dc 16} Constitution saving throw or be {@condition stunned} until the end of Valin's next turn.",
        ],
      },
      {
        name: "Channel Negative Energy (Costs 2 Actions)",
        entries: [
          "Valin magically unleashes negative energy. Creatures within 60 feet of Valin, including ones behind barriers and around corners, can't regain hit points until the end of Valin's next turn.",
        ],
      },
      {
        name: "Whirlwind of Sand (Costs 2 Actions)",
        entries: [
          "Valin magically transforms into a whirlwind of sand, moves up to 60 feet, and reverts to her normal form. While in whirlwind form, Valin is immune to all damage, and it can't be {@condition grappled}, {@condition petrified}, knocked {@condition prone}, {@condition restrained}, or {@condition stunned}. Equipment worn or carried by Valin remain in her possession.",
        ],
      },
    ],
    legendaryGroup: {
      name: "Valin Sarnaster",
      source: "CM",
    },
    traitTags: ["Magic Resistance", "Rejuvenation"],
    senseTags: ["D"],
    actionTags: ["Multiattack"],
    languageTags: ["LF"],
    damageTags: ["B", "N"],
    damageTagsSpell: ["N", "O", "R"],
    spellcastingTags: ["CC"],
    miscTags: ["AOE", "MW"],
    conditionInflict: ["blinded", "frightened", "paralyzed", "stunned"],
    conditionInflictSpell: [
      "blinded",
      "deafened",
      "paralyzed",
      "poisoned",
      "prone",
      "stunned",
    ],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Varnyr",
    isNpc: true,
    isNamedCreature: true,
    source: "CM",
    page: 63,
    size: ["M"],
    type: {
      type: "humanoid",
      tags: ["elf"],
    },
    alignment: ["C", "G"],
    ac: [
      {
        ac: 15,
        from: ["{@item breastplate|PHB}"],
      },
    ],
    hp: {
      average: 9,
      formula: "2d8",
    },
    speed: {
      walk: 30,
    },
    str: 11,
    dex: 12,
    con: 11,
    int: 12,
    wis: 14,
    cha: 16,
    skill: {
      deception: "+5",
      insight: "+4",
      persuasion: "+5",
    },
    senses: ["darkvision 60 ft."],
    passive: 12,
    languages: ["Common", "Elvish"],
    cr: "1/8",
    trait: [
      {
        name: "Fey Ancestry",
        entries: [
          "Varnyr has advantage on saving throws against being {@condition charmed}, and magic can't put Varnyr to sleep.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: ["Varnyr makes two attacks."],
      },
      {
        name: "Cane",
        entries: [
          "{@atk mw} {@hit 3} to hit, reach 5 ft., one target. {@h}2 ({@damage 1d4}) bludgeoning damage.",
        ],
      },
    ],
    reaction: [
      {
        name: "Parry",
        entries: [
          "Varnyr adds 2 to their AC against one melee attack that would hit it. To do so, Varnyr must see the attacker and be wielding a melee weapon.",
        ],
      },
    ],
    traitTags: ["Fey Ancestry"],
    senseTags: ["D"],
    actionTags: ["Multiattack", "Parry"],
    languageTags: ["C", "E"],
    damageTags: ["B"],
    miscTags: ["MW"],
    hasToken: true,
    hasFluff: true,
  },
  {
    name: "Wood Elf Wizard",
    source: "CM",
    page: 187,
    _copy: {
      name: "Drow Mage",
      source: "MM",
      _mod: {
        "*": {
          mode: "replaceTxt",
          replace: "\\bdrow\\b",
          with: "wood elf",
        },
        trait: {
          mode: "removeArr",
          names: "Sunlight Sensitivity",
        },
      },
    },
    traitTags: ["Fey Ancestry"],
    hasToken: true,
  },
  {
    name: "Zikran",
    isNpc: true,
    isNamedCreature: true,
    source: "CM",
    page: 145,
    _copy: {
      name: "Archmage",
      source: "MM",
      _trait: {
        name: "Water Genasi",
        source: "EEPC",
      },
      _mod: {
        "*": {
          mode: "replaceTxt",
          replace: "the archmage",
          with: "Zikran",
          flags: "i",
        },
        _: {
          mode: "addSpells",
          spells: {
            5: {
              spells: ["{@spell conjure elemental}"],
            },
          },
        },
      },
    },
    hp: {
      average: 144,
      formula: "18d8 + 18",
    },
    languages: ["Aquan", "Common", "Primordial", "Sahuagin", "Undercommon"],
    traitTags: ["Amphibious", "Magic Resistance"],
    languageTags: ["AQ", "C", "OTH", "P", "U"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
  {
    name: "Zikzokrishka",
    isNpc: true,
    isNamedCreature: true,
    source: "CM",
    page: 209,
    size: ["H"],
    type: "undead",
    alignment: ["L", "E"],
    ac: [
      {
        ac: 19,
        from: ["natural armor"],
      },
    ],
    hp: {
      average: 225,
      formula: "18d12 + 108",
    },
    speed: {
      walk: 40,
      burrow: 30,
      fly: 80,
    },
    str: 25,
    dex: 10,
    con: 23,
    int: 16,
    wis: 15,
    cha: 19,
    save: {
      dex: "+6",
      con: "+12",
      wis: "+8",
      cha: "+10",
    },
    skill: {
      perception: "+14",
      stealth: "+6",
    },
    senses: ["blindsight 60 ft.", "darkvision 120 ft."],
    passive: 24,
    resist: ["necrotic"],
    immune: ["lightning", "poison"],
    conditionImmune: [
      "charmed",
      "exhaustion",
      "frightened",
      "paralyzed",
      "poisoned",
    ],
    languages: ["Common", "Draconic"],
    cr: "17",
    trait: [
      {
        name: "Legendary Resistance (3/Day)",
        entries: [
          "If Zikzokrishka fails a saving throw, it can choose to succeed instead.",
        ],
      },
      {
        name: "Magic Resistance",
        entries: [
          "Zikzokrishka has advantage on saving throws against spells and other magical effects.",
        ],
      },
    ],
    action: [
      {
        name: "Multiattack",
        entries: [
          "Zikzokrishka can use its Frightful Presence. It then makes three attacks: one with its bite and two with its claws.",
        ],
      },
      {
        name: "Bite",
        entries: [
          "{@atk mw} {@hit 13} to hit, reach 10 ft., one target. {@h}18 ({@damage 2d10 + 7}) piercing damage plus 5 ({@damage 1d10}) lightning damage.",
        ],
      },
      {
        name: "Claw",
        entries: [
          "{@atk mw} {@hit 13} to hit, reach 5 ft., one target. {@h}14 ({@damage 2d6 + 7}) slashing damage.",
        ],
      },
      {
        name: "Tail",
        entries: [
          "{@atk mw} {@hit 13} to hit, reach 15 ft., one target. {@h}16 ({@damage 2d8 + 7}) bludgeoning damage.",
        ],
      },
      {
        name: "Frightful Presence",
        entries: [
          "Each creature of Zikzokrishka's choice that is within 120 feet of the Zikzokrishka and aware of it must succeed on a {@dc 18} Wisdom saving throw or become {@condition frightened} for 1 minute. A creature can repeat the saving throw at the end of each of its turns, ending the effect on itself on a success. If a creature's saving throw is successful or the effect ends for it, the creature is immune to the Zikzokrishka's Frightful Presence for the next 24 hours.",
        ],
      },
      {
        name: "Lightning Breath {@recharge 5}",
        entries: [
          "Zikzokrishka exhales lightning in a 90-foot line that is 5 feet wide. Each creature in that line must make a {@dc 20} Dexterity saving throw, taking 66 ({@damage 12d10}) lightning damage on a failed save, or half as much damage on a successful one.",
        ],
      },
    ],
    legendary: [
      {
        name: "Detect",
        entries: ["Zikzokrishka makes a Wisdom (Perception) check."],
      },
      {
        name: "Tail Attack",
        entries: ["Zikzokrishka makes a tail attack."],
      },
      {
        name: "Wing Attack (Costs 2 Actions)",
        entries: [
          "Zikzokrishka beats its tattered wings. Each creature within 10 feet of Zikzokrishka must succeed on a {@dc 21} Dexterity saving throw or take 14 ({@damage 2d6 + 7}) bludgeoning damage and be knocked {@condition prone}. After beating its wings this way, Zikzokrishka can fly up to half its flying speed.",
        ],
      },
    ],
    legendaryGroup: {
      name: "Zikzokrishka",
      source: "CM",
    },
    traitTags: ["Legendary Resistances", "Magic Resistance"],
    senseTags: ["B", "SD"],
    actionTags: ["Breath Weapon", "Frightful Presence", "Multiattack"],
    languageTags: ["C", "DR"],
    damageTags: ["B", "L", "P", "S"],
    damageTagsLegendary: ["B", "L"],
    miscTags: ["AOE", "MW", "RCH"],
    conditionInflict: ["frightened", "prone"],
    hasToken: true,
    hasFluff: true,
    hasFluffImages: true,
  },
];
